import { useEffect, useState } from 'react';
import Icon from '../../components/tables/Icon';
import IconAdd from '../../components/icons/IconAdd';
import WordSearchSelect from '../students/WordSearchSelect';
import * as api from './api';

// ExerciseTemplateWord side-panel - reuses WordSearchSelect.jsx as-is
// (already generic value/onChange/placeholder, zero coupling to students).
export default function WordPanel({ exerciseId }) {
   const [words, setWords] = useState([]);
   const [pickedWordId, setPickedWordId] = useState('');
   const [adding, setAdding] = useState(false);
   const [refresh, setRefresh] = useState(0);
   const reloadWords = () => setRefresh(prev => prev + 1);

   useEffect(() => {
      api.getExerciseWords(exerciseId)
         .then(response => setWords(Array.isArray(response.data) ? response.data : []))
         .catch(() => setWords([]));
   }, [exerciseId, refresh]);

   const handleAdd = () => {
      if(!pickedWordId || adding) return;
      setAdding(true);
      api.createExerciseWord(exerciseId, pickedWordId)
         .then(() => { setPickedWordId(''); reloadWords(); })
         .catch(err => console.error(err))
         .finally(() => setAdding(false));
   };

   return (
      <div className='exercise-word-panel'>
         <h3 className='exercise-word-panel-title'>Слова вправи</h3>
         <div className='exercise-word-panel-list'>
            {words.map(w => (
               <div className='exercise-word-chip' key={w.id}>
                  <span>{w.word ? w.word.word : ''}</span>
                  <Icon mode='delete' url={'/api/exercisetemplatewords/' + w.id} onRefreshHundler={reloadWords} className='icon-delete' classes='icon-dimensions-tiny' />
               </div>
            ))}
            {words.length === 0 ? <p className='exercise-block-empty-hint'>Ще немає слів</p> : ''}
         </div>
         <div className='exercise-word-panel-add-row'>
            <WordSearchSelect value={pickedWordId} onChange={setPickedWordId} placeholder='Пошук слова...' />
            <div className='exercise-word-panel-add-btn' onClick={handleAdd} title='Додати слово'>
               <IconAdd />
            </div>
         </div>
      </div>
   );
}
